import {useMemo} from "react";
import {GeneInfo} from "../types/Types";
import {useFileGenes} from "./useJsonLoader";

export function useEntrezMap() {
  const genes = useFileGenes();

  return useMemo(() => {
    const map: Record<number, GeneInfo> = {};

    genes?.forEach((gene) => {
      map[gene.e] = gene;
    });

    return Object.keys(map).length === 0 ? undefined : map;
  }, [genes]);
}
